import { Routes } from '@angular/router';
import { ReportsWorkspaceComponent } from './reports-workspace.component';

export const reportingRoutes: Routes = [
    {
        path: 'reports',
        component: ReportsWorkspaceComponent
    }
];
